<template>
  <base-modal-bottom
    ref="baseModalPassword"
    class="has-text-centered"
    :withClickOverlay="false"
    :isFooter="true"
    :title="title"
    :onClose="onCloseModal"
  >
    <template #btn-close-icon>
      <div class="button-close-custom">
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </div>
    </template>
    <div class="c-modal-password">
      <div class="margin-bottom c-modal-password--max-width">
        <p>{{ message }}</p>
      </div>
      <br />
      <p
        v-if="isWithdraw"
        class="margin-bottom c-modal-password--max-width c-modal-password__value"
      >
        Valor solicitado: <span>{{ value | currency }}</span>
      </p>

      <div v-if="!isWithdraw" class="c-modal-password__default">
        <div class="c-modal-password--max-width">
          <p class="c-modal-password__default--logo">Casar.com</p>
          <p class="c-modal-password__default--info">
            {{ user && user.name }}<br /><span>{{ user && user.cpf }}</span>
          </p>
        </div>
      </div>
      <div v-else>
        <div class="c-modal-password__default">
          <div class="c-modal-password--max-width">
            <p
              class="c-modal-password__default--logo c-modal-password__pix--logo"
            >
              PIX
            </p>
            <p class="c-modal-password__default--info">
              {{ userDataTransfer && userDataTransfer.owner_full_name }}
              <br />
              <span>
                {{ userDataTransfer && userDataTransfer.owner_cpf }}
                {{ userDataTransfer && bankName }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field-body column c-modal-password--max-width">
        <div class="field">
          <div class="control" autocomplete="off">
            <base-input
              v-on:input="password = $event"
              v-on:keyup.enter="submitPassword()"
              :value="password"
              :hasError="password_error ? true : false"
              :firstError="password_error"
              :isPassed="!password_error"
              :placeholder="'Digite sua senha'"
              :type="'password'"
              :hasIcon="false"
            >
            </base-input>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <base-button-bottom
        :disabled="!password"
        @click.native="submitPassword()"
        class="is-primary is-big"
        type="button"
      >
        Confirmar
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import BaseInput from '@/components/BaseInput.vue'
import SimpleVueValidator from 'simple-vue-validator'

import AccountApi from '@/lib/api/Account'

export default {
  mixins: [SimpleVueValidator.mixin],

  props: {
    title: {
      type: String,
      default: 'Confirmação de senha',
    },
    message: {
      type: String,
      default:
        'Insira sua senha de acesso do Casar.com para confirmar a transferência por PIX.',
    },
    value: {
      type: Number,
      default: null,
    },
    userData: {
      type: Object,
      default: null,
    },
    isWithdraw: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
    BaseInput,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    userDataTransfer() {
      return this.$store.state.wallet.userDataTransfer
    },

    bankName() {
      if (this.userDataTransfer?.bank?.name)
        return ` . ${this.userDataTransfer.bank.name}`
      return ''
    },
  },

  data() {
    return {
      tokenValid: false,
      password_error: null,
      password: '',
      user: null,
    }
  },

  created() {
    if (this.userData) {
      this.user = this.userData
    }
  },

  watch: {
    password() {
      this.password_error = null
    },
  },

  methods: {
    open() {
      this.$refs.baseModalPassword.open()
    },

    onCloseModal() {
      this.password = null
      this.sendToken(this.tokenValid)
    },

    submitPassword() {
      const data = {
        wed_id: this.logonToken.token_payload.wed_id,
        senha: this.password,
      }

      const accountApi = new AccountApi(this.logonToken)
      accountApi
        .getTokenExtra(data)
        .then((response) => {
          const token = response.data?.token
          const errors = response.data?.errors

          if (!token) {
            this.password_error =
              errors?.login_invalido ||
              'Senha incorreta, por favor tente novamente'
          } else {
            this.tokenValid = token
            this.$refs.baseModalPassword.close()
          }
        })
        .catch(function () {
          this.tokenValid = 'error'
          this.$refs.baseModalPassword.close()
        })
    },

    sendToken(tokenExtra) {
      this.$emit('token-extra', { token: tokenExtra })
    },
  },
}
</script>

<style lang="scss">
.c-modal-password {
  &--max-width {
    max-width: 325px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  &__value {
    span {
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
      color: $support;
    }
  }

  &__default {
    background-color: $gray-2;
    padding: 10px;

    &--logo {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.33;
      color: #048a8b;
    }

    &--info {
      font-size: 16px;
      font-weight: bold;
      color: $gray-6;

      span {
        font-size: 14px;
        font-weight: normal;
      }
    }
  }

  &__pix {
    &--logo {
      font-size: 14px;
    }
  }
}

.field-body {
  margin-top: 20px;
}

.button-close-custom {
  width: 40px;
  line-height: 0;
}
</style>
